<template>
  <div class="history_home">
    <common-header></common-header>
    <time-nav @changeYear="changeYear"></time-nav>
    
    <div class="work_wrap">
      <ul class="work_nav clearfix">
        <li @click="changeNav(0)" :class="{'active': navKey == 0}">
          短视频
          <span class="en_nav">VLOG</span>
        </li>
        <li @click="changeNav(1)" :class="{'active': navKey == 1}">
          图组
          <span class="en_nav">PLOG</span>
        </li>
        <li @click="changeNav(2)" :class="{'active': navKey == 2}">
          单图
          <span class="en_nav">PLOG</span>
        </li>
      </ul>
      <ul class="work_list clearfix">
        <li v-for="(v, i) in workList" :key="i" @click="goDetail(v)">
          <img src="../../img/m/video_btn.png" alt="" class="play_btn" v-if="navKey == 0">
          <img :src="navKey == 0 ? 'https://collection2021-cos.chineseplus.net/'+v.video_cover : 'https://collection2021-cos.chineseplus.net/'+v.cover" alt="" >
        </li>
      </ul>

      <div class="more" v-if="showMore" @click="getMore()">更多     MORE</div>
    </div>

    <common-footer></common-footer>
  </div>
</template>

<script>
import timeNav from './common/timeNav'
import commonHeader from '../common/commonHeader2'
import commonFooter from '../common/commonFooter'

export default {
  components: {
    timeNav,
    commonHeader,
    commonFooter
  },
  data () {
    return {
      type: 1,
      yearList: [
        {
          value: '2015'
        },
        {
          value: '2016'
        },
        {
          value: '2017'
        },
        {
          value: '2018'
        },
        {
          value: '现在'
        }
      ],
      yearIndex: 0,
      navKey: 0,
      workList: [],
      page: 1,
      pageSize: 12,
      total: 0,
      showMore: true
    }
  },
  created () {
    this.navKey = this.$route.query.type - 1
    this.changeNav(this.navKey)
  },
  methods: {
    changeYear (yearIndex) {
      this.yearIndex = yearIndex
      this.$router.push({
        path: this.$route.path,
        query: {
          year: yearIndex,
          type: this.navKey + 1
        }
      })
      this.page = 1
      this.workList = []
      this.workList.length = 0
      this.getList(this.navKey)
    },
    changeNav (key) {
      this.navKey = key
      this.page = 1
      this.workList = []
      this.workList.length = 0
      this.getList(key)
    },
    // 获取列表
    getList () {
      this.$utils.get('/works/list-history', {
        year: this.yearList[this.$route.query.year].value.substr(0, 4),
        type: this.navKey + 1,
        page: this.page,
        pageSize: this.pageSize
      }).then(res => {
        if(res.code == 1000) {
          this.showMore = true
          if (!res.data.list.length) {
            this.showMore = false
          }
          this.workList.push(...res.data.list)
          this.workList = this.workList.filter(v => {
            return v.type == this.navKey + 1
          })
          this.total = res.data.total
          if (this.workList.length == res.data.total) {
            this.showMore = false
          }
        }
      })
    },
    // 去详情
    goDetail (item) {
      let path = ''
      if (item.type == 1) {
        path = '/mpage/m_history_videoworksInfo'
      } else {
        path = '/mpage/m_history_picworksInfo'
      }
      this.$router.push({
        path,
        query: {
          id: item.works_id
        }
      })
    },
    getMore () {
      this.page++
      this.getList()
    }
  },
}
</script>

<style scoped lang="scss">
.history_home {
  width: 100%;
  height: 100%;
  margin: auto;
  font-size: .3rem;;
  .work_wrap {
    width: calc(100% - .9rem);
    margin: auto;
    background: rgba(255, 255, 255, .8);
    box-sizing: border-box;
    margin-top: 1.2rem;
    padding: 0 .34rem;
    padding-bottom: 0.5rem;
    .work_nav {
      color: #fff;
      width: max-content;
      margin: auto;
      // margin-top: -.6rem;
      position: relative;
      top: -.6rem;
      li {
        width: 4rem;
        height: 1.2rem;
        background-image: linear-gradient(0deg, 
          #aba7e2 0%, 
          #dbd9f6 100%);
        border-radius: .58rem;
        font-size: .5rem;
        font-weight: bold;
        text-align: center;
        line-height: 1.2rem;
        float: left;
        margin-right: .35rem;
        cursor: pointer;
        &.active {
          background-image: linear-gradient(0deg, 
        #746bef 0%, 
        #728bf9 100%);
        }
        &:last-child {
          margin-right: 0;
        }
        .en_nav {
          color: rgba(255, 255, 255, .8);
          font-size: .45rem;
          font-weight: bold;
        }
      }

    }
    .work_list {
      li {
        float: left;
        margin-bottom: .35rem;
        width: calc((100% - .33rem) / 2);
	      height: 3.9rem;
        position: relative;
        cursor: pointer;
        margin-right: .33rem;
        &:nth-child(2n) {
          margin-right: 0;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
        .play_btn {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
          width: .95rem;
          height: .95rem;

        }
      }
    }
    .more {
      width: 100%;
      height: 1.2rem;
	    background-color: #9576ef;
      font-size: .45rem;
      color: #fff;
      line-height: 1.2rem;
      text-align: center;
    }
  }
}
</style>
